import {
	DataKYCFileTctWithFile,
	KycEventLogAction,
	KycEventLogEntity,
	KycEventLogHistoryRes,
} from '@dealstack/shared/lib/generated';

export const findFormUploaderName = (
	kycFile: DataKYCFileTctWithFile,
	kycHistory: KycEventLogHistoryRes | undefined
): string | undefined => {
	const formEvents = kycHistory?.FORM ?? [];
	const candidates = formEvents.filter(
		(event) =>
			event.action === KycEventLogAction.SUBMITTED && event.file?.name === kycFile.file?.name
	);
	if (candidates.length === 0) {
		return undefined;
	}
	const mostRecent = candidates.reduce<KycEventLogEntity>(
		(acc, event) => (event.createdAt > acc.createdAt ? event : acc),
		candidates[0]
	);
	const { firstName, lastName } = mostRecent.userAction.userSession.user;
	const name = [firstName, lastName].filter(Boolean).join(' ').trim();
	return name || undefined;
};
